<div class="container">
  <notifier-container></notifier-container>
  <div class="header-bar">
    <div id="logo">
      <img src="https://atouch.ch/wp-content/uploads/2020/08/logo-120.png" alt="aTouch – Enabling Teams">
    </div>
  </div>
  <div>
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3840 1910" preserveAspectRatio="none">
      <path d="M0 131.079C0 131.079 452.65 149.272 741.582 131.079C1054.84 111.354 1224.81 52.6287 1537.48 26.0733C2108.24 -22.4042 2432.35 8.25817 3005.22 26.0733C3331.49 36.2199 3840 66.8402 3840 66.8402V1860.58C3840 1860.58 3228.39 1910.38 2835.58 1910C2116.82 1909.3 1713.12 1849.91 1004.42 1739.52C609.413 1677.99 0 1547.42 0 1547.42V131.079Z" fill="#CF0254"/>
    </svg>
    <img class="example-image" src="https://atouch.ch/wp-content/uploads/2020/09/atouch-05-e1599835667608-2048x1401.png" alt="Representing Image" >
    <div class="login-form">
      <h1>aWall</h1>
      <h2>Connect. Collaborate. Create.</h2>
      <h3>{{instructionText}}</h3>
      <Button class="button-primary" (click)="login()">
        <img src="assets/images/atlassian_logo.svg" alt="Representing Image">
        <p class="button-text-primary">{{loginAtlassianText}}</p>
      </Button>
      <Button class="button-secondary" (click)="continueWithoutLogin()">
        <p class="button-text-secondary">{{loginWithoutText}}</p>
      </Button>
    </div>
  </div>
</div>


